import UNIQUE from '@/common/unique'

export default {
  id: 'carousel',
  name: 'carousel',
  type: 'standard',
  moduleName: 'editor_module_slide',
  dataSet: {
    mods: 'carousel',
    column: [
      {
        columnId: UNIQUE.mid(),
        type: 'carousel',
        value: [
          { value: '', link: null }
        ],
        detail: {
          // options: ['link', 'carousel']
          options: ['carousel', 'radius']
        }
      }
    ]
  },
  setting: {
    layout: {
      options: [
        'fullsize',
        'background',
        'border',
        'padding'
      ]
    },
    action: null,
    detail: {}
  }
}
